import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import { faPartyHorn } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogContent } from '@mui/material';
import { ClassNameMap } from '@mui/styles';
import { closeModal } from '@stores/actions/modal.action';
import { ModalStore } from '@stores/models/store';
import JSConfetti from 'js-confetti';
import OverrideTheme from 'themes/custom-theme-helper';

import DialogTitle from './DialogTitle';

interface Props {
  modal: ModalStore;
  classes: ClassNameMap<
    | 'cardContainer'
    | 'closeIcon'
    | 'successIcon'
    | 'modalContainer'
    | 'cardContent'
    | 'confettiWrapper'
  >;
}

const ModalWithConfetti = ({ modal, classes }: Props) => {
  const dispatch = useDispatch();
  const confetti = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (confetti.current && modal.show) {
      const canvas = confetti.current;
      const jsConfetti = new JSConfetti({ canvas });
      jsConfetti.addConfetti({ confettiNumber: 500, confettiRadius: 10 });
    }
  }, [modal.show]);

  return (
    <>
      <canvas ref={confetti} className={classes.confettiWrapper} />
      <Dialog
        open={modal.show}
        onClose={(event, reason) => {
          if (
            false === modal.preventClose ||
            (reason !== 'backdropClick' && reason !== 'escapeKeyDown')
          ) {
            dispatch(closeModal());
          }
        }}
      >
        {modal.withHeader && (
          <DialogTitle
            id="customized-dialog-title"
            withCloseBtn={modal.withCloseBtn}
            onClose={() => dispatch(closeModal())}
          >
            <FontAwesomeIcon
              icon={faPartyHorn}
              size="sm"
              className={classes.successIcon}
              color={OverrideTheme.colors.notification}
            />
            {modal.title}
          </DialogTitle>
        )}
        <DialogContent
          className={`${modal.className || ''} ${classes.cardContainer}`}
        >
          {modal.component}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ModalWithConfetti;
